import Vue from 'vue'
import VCalendar from 'v-calendar'

Vue.use(VCalendar, {
  firstDayOfWeek: 2, // Monday
  locale: 'en'
})